import { createSlice, createAction } from '@reduxjs/toolkit';
import { IState } from 'shared/interfaces/state.interface';
import { initialStore } from '../initial-store';
import { IAffiliate } from 'shared/interfaces/affiliate.interface';

// Actions
export const createStripeSetupIntent = createAction(
  'settings/CREATE_STRIPE_SETUP_INTENT'
);

export const addPaymentMethod = createAction(
  'settings/ADD_PAYMENT_METHOD',
  (payload) => ({ payload })
);

export const getUser = createAction('settings/GET_USER');

export const getPaymentMethods = createAction('settings/GET_PAYMENT_METHODS');

export const getCurrentAffiliate = createAction('settings/GET_AFFILIATE');

export const getAffiliateUserAdmins = createAction(
  'settings/GET_AFFILIATE_ADMINS'
);
export const updateAffiliateData = createAction(
  'settings/UPDATE_AFFILIATE_ADMINS',
  (payload) => ({ payload })
);

export const updateAffiliatePaymentProcessorsKeys = createAction(
  'settings/UPDATE_AFFILIATE_PAYMENT_PROCESSORS_KEYS',
  (payload) => ({ payload })
);

const settingsSlice = createSlice({
  name: 'settings',
  initialState: initialStore.settings,
  reducers: {
    setCurrentUser: (state, { payload }) => {
      state.currentUser = payload;
      state.isLoading = false;
    },
    setCurrentAffiliate: (state, { payload }) => {
      state.affiliate = payload;
      state.isLoading = false;
    },

    updateAffiliateDataSuccess: (state, { payload }) => {
      state.affiliate = payload;
    },
    updateAffiliateDataFail: (state) => {
      if (state.affiliate && typeof state.affiliate === 'object') {
        (state.affiliate as IAffiliate) = {
          ...(state.affiliate as IAffiliate)
        };
      }
      state.isLoading = false;
    },
    setStripeSetupInter: (state, { payload }) => {
      state.paymentMethod.setupIntent = payload.client_secret;
    },
    addNewCard: (state, { payload }) => {
      state.paymentMethod.card = payload;
    },
    setPaymentMethods: (state, { payload }) => {
      state.paymentMethod.card = payload;
      state.paymentMethod.isLoading = false;
    },
    updateAdminData: (state, data) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
    },
    getAffiliatePaymentProcessorsKeys: (state) => {
      state.isLoading = true;
    },
    setPaymentProcessorsKeys: (state, { payload }) => {
      state.paymentProcessorsKeys = payload;
      state.isLoading = false;
    },

    updateAffiliatePaymentProcessorsKeysSuccess: (state, { payload }) => {
      state.paymentProcessorsKeys = payload;
      state.isLoading = false;
    },
    updateAffiliatePaymentProcessorsKeysFail: (state) => {
      state.isLoading = false;
    }
  }
});

export const {
  setStripeSetupInter,
  setCurrentUser,
  setCurrentAffiliate,
  addNewCard,
  setPaymentMethods,
  updateAffiliateDataSuccess,
  updateAffiliateDataFail,
  setPaymentProcessorsKeys,
  getAffiliatePaymentProcessorsKeys,
  updateAffiliatePaymentProcessorsKeysSuccess,
  updateAffiliatePaymentProcessorsKeysFail
} = settingsSlice.actions;

export const { reducer } = settingsSlice;

// Selectors
export const getSettingsLoadingSelector = (state: IState) =>
  state && state.settings.isLoading;

export const getSetupIntentSelector = (state: IState) =>
  state && state.settings.paymentMethod.setupIntent;

export const getCardSelector = (state: IState) =>
  state && state.settings.paymentMethod.card;

export const getPaymentMethodsLoadingSelector = (state: IState) =>
  state && state.settings.paymentMethod.isLoading;

export const getCurrentUserSelector = (state: IState) =>
  state && state.settings.currentUser;

export const getAffiliateSelector = (state: IState) =>
  state && state.settings.affiliate;

export const getAffiliatePaymentProcessorsKeysSelector = (state: IState) =>
  state && state.settings.paymentProcessorsKeys;
